<template>
    <div class="dataHeader">
      <div class="storeTitle" @click="storeSelect">
        <span>{{getResturantName}}</span>
        <img src="../common/image/多边形1.png" alt="" width="7">
      </div>
      <mt-popup v-model="popupVisible" popup-transition="popup-fade" class="mintPopup" position="bottom">
        <div class="pickerWraper">
          <div class="picker">
            <div class="popupItem" v-for="(it, index) in slots" :class="{active:index==nowcount}" @click="nowcount=index" :key="index">
              <span class="popupText" v-text="it.restaurantName"></span>
            </div>
          </div>
        </div>
        <div class="makeSure" @click="ale(nowcount)">
          <span>确认</span>
        </div>
      </mt-popup>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import eventBus from 'common/js/eventBus.js'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      nowcount: -1,
      popupVisible: false,
      slots: [],
      title: '营业数据概况',
      staticDataType: false
    }
  },
  computed: {
    getResturantId: function() {
      return this.$store.state.resturantId
    },
    getResturantName: function() {
      return this.$store.state.resturantName
    },
    getStatisticalDate: function() {
      if (this.$store.state.statisticalDate === '') {
        this.staticDataType = true
      } else {
        this.staticDataType = false
      }
      return this.$store.state.statisticalDate
    }
  },
  mounted() {
    this.getAxiosData()
    this.getTitle()
  },
  methods: {
    ...mapActions([
      'changeResturantId', // 映射 this.increment() 为 this.$store.dispatch('increment')
      'changeResturantName'
    ]),
    getTitle() {
      const that = this
      eventBus.$on('changeHeaderTitle', function(val) {
        console.log('val' + val)
        that.title = val
        console.log('this.title' + this.title)
      })
    },
    getAxiosData() {
      const _this = this
      this.$http.get(this.common.url_user + '/managerqueryrestaurant', {
        params: {
          userId: _this.common.localGet('loginInfo').userId,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        console.log(response)
        if (response.data.code === 0) {
          _this.slots = response.data.data
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    storeSelect() {
      this.popupVisible = true
    },
    ale(a) {
      if (a === -1) {
        this.$toast('请先选择店铺')
        return
      }
      this.popupVisible = false
      this.changeResturantId(this.slots[this.nowcount].id)  // vuex维护resturantId
      this.changeResturantName(this.slots[this.nowcount].restaurantName) // vuex维护resturantName
      this.$emit('select-resturantId', this.slots[this.nowcount].id)
    }
  }
}
</script>
<style scoped>
  .dataHeader{
    width: 50%;
  }
  .colorGradient{
    width:100%;
    height: 0.1rem;
    background:linear-gradient( top,#ccc,#000);
  }
  .storeTitle{
    display:flex;
    display: -webkit-flex; 
    justify-content:flex-end;
    align-items:center;
    color: #f74d47;
    padding-right: 0.2rem;
  }
  .storeTitle span{
    margin-right: 0.12rem;
  }
  .storeTitle img{
    width: 0.18rem;
    height:0.18rem;
  }
  .mintPopup{
    width: 100%;
    background-color: #787979;
  }
  .pickerWraper{
    width:calc(100% - 0.2rem);
    margin-left:0.1rem;
    overflow: hidden;
    background:#fff;
    height: 4rem;
    border-radius:0.1rem;
    margin-bottom:0.2rem;

  }
  .picker{
    width:calc(100% + 0.3rem);
    position: relative;
    text-align: center;
    overflow: hidden;
    height: 4rem;
    overflow: auto;
    font-size: 0.4rem;
    margin-bottom:0.2rem;
    background:#fff;
    border-radius:0.1rem;
  }
  .picker:before{
    content: '';
    position: fixed;
    height: 0.5rem;
    width: -webkit-calc(100% - 0.2rem);
    top: 0;
    left: 0.1rem;
    background: #fff;
    opacity: 0.9;
    margin: auto;
    box-sizing: border-box;
    border-radius:0.1rem;
  }
  .picker:after{
    content: '';
    position: fixed;
    height: 0.5rem;
    width: -webkit-calc(100% - 0.2rem);
    bottom: 1.38rem;
    left: 0.1rem;
    background: #fff;
    opacity: 0.9;
    margin: auto;
     box-sizing: border-box;
    border-radius:0.1rem;
    
  }
  .picker .popupItem{
    height:0.9rem;
    line-height:0.9rem;
    font-size: 0.34rem;
  }
  .picker .popupItem:first-child{
    margin-top:0.5rem;
  }
  .picker .popupItem:last-child{
     margin-bottom:0.5rem;
   }
  .makeSure{
    height: 0.98rem;
    background-color: #fff;
    border-radius: 0.1rem;
    text-align: center;
    line-height: 0.98rem;
    margin:0 0.1rem 0.2rem 0.1rem;
    color:#f74d47;
    font-size:0.34rem;
  }
  .makeSure span{
     font-weight:900;
  }
  .active{
    background-color: #f1f2f3;
  }
  .active span {
    color:#f74d47;
  }
  span{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap/*文本不换行*/;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataHeader.vue